export const items = [
    {
        id: 1,
        name: 'Даша',
        avatar: '/images/1.png',
        stars: 8,
        text: 'Коли я ділилася враженнями з мамою, вона сказала: «Я відправляю тебе в цей табір, бо бачу, що там ти можеш навчитися речам, які я сама тебе навчити не в взмозі» і після цих слів, я зрозуміла, наскільки трансформаційною є вся програма загалом! Чи важко в таборі? Та звісно! Кожна секунда розписана, розмови виключно англійською, телефони тільки на годину в день. Але тільки після цього тижня ти розумієш, що повертаєшся додому зовсім іншою людиною',
    },
    {
        id: 2,
        name: 'Іра',
        avatar: '/images/2.jpg',
        stars: 6,
        text: 'RaceCamp показав мені як легко можна зріднитися з новими людьми усього за тиждень, допоміг відкрити в мені багато нового та подолати безліч перешкод, які стали такими легкими після табору. Безмежно ціную кожного, кого я зустріла в таборі, адже, без перебільшення, кожен став частинкою чогось великого!',
    },
    {
        id: 3,
        name: 'Ліза',
        avatar: '/images/3.png',
        stars: 5,
        text: 'Це такий кайф коли в кожній секунді, кожній пісні і кожному танці ти відчуваєш такий сильний вайб кемпу. Коли ти живеш із загоном, що як одні сімʼя. Ви разом смієтеся, а потім разом плачете, бо табір ось-ось закінчився! Дякую вам за те, що створили всі ці емоції',
    },
];
